// Accessing sessionStorage can throw a SecurityError (e.g. in cross-origin
// iframe embeds like payment link previews, or browsers/extensions that block
// storage access), so every access needs to be guarded.

export const getSessionStorageItem = key => {
  try {
    return sessionStorage.getItem(key);
  } catch (_unused) {
    return null;
  }
};
export const setSessionStorageItem = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch (_unused2) {
    // sessionStorage inaccessible; nothing to persist
  }
};
export const removeSessionStorageItem = key => {
  try {
    sessionStorage.removeItem(key);
  } catch (_unused3) {
    // sessionStorage inaccessible; nothing to remove
  }
};